import React from 'react'
import { Formik, Form } from 'formik'
import {
  InputField,
  InputSelectOptions,
  LoaderButton
} from 'components/molecules'
import PropTypes from 'prop-types'
import { STATUS } from 'domains/customer-order/constants'
import { orderTextInputFields, customerTextInputFields } from './customer-order-filter-form-fields'
import { Label } from 'reactstrap'

const propTypes = {
  filterValues       : PropTypes.object.isRequired,
  onClickSubmitForm  : PropTypes.func.isRequired,
  onClickReset       : PropTypes.func.isRequired,
  showCustomerFields : PropTypes.bool
}

const defaultProps = {
  showCustomerFields: true
}

/**
 * Form to filters Customer::Order data
 * @param {Object} filterValues - current url filter values
 * @param {Function} onClickSubmitForm - function to submit form
 * @param {Function} onClickReset - function to reset form
 * @param {Boolean} showCustomerFields - show customer related fields
 */

const CustomerOrderFilterForm = ({
  filterValues,
  onClickSubmitForm,
  onClickReset,
  showCustomerFields
}) => (
  <Formik
    initialValues={{
      per_page            : filterValues.per_page || 10,
      sort_by             : filterValues.sort_by || 'created_at',
      sort_dir            : filterValues.sort_dir || 'desc',
      number              : filterValues.number || '',
      status              : filterValues.status || '',
      payment_method_name : filterValues.payment_method_name || '',
      discount_code       : filterValues.discount_code || '',
      item_sku            : filterValues.item_sku || '',
      customer_name       : filterValues.customer_name || '',
      email               : filterValues.email || '',
      customer_phone      : filterValues.customer_phone || '',
      customer_id         : filterValues.customer_id || '',
      affiliate_name      : filterValues.affiliate_name || ''
    }}
    enableReinitialize={ true }
    onSubmit={ onClickSubmitForm }
  >
    {
      ({ isSubmitting }) => (
        <Form>
          <Label className='mb-3 font-weight-bold'>{ 'Order Filter' }</Label>
          <InputField
            type='select'
            name='status'
            label='Order Status'
            size={ 'sm' }
          >
            <option
              key=''
              value=''
              className='text-capitalize'
            >
              { 'Choose One' }
            </option>
            <InputSelectOptions
              options={ STATUS }
            />
          </InputField>

          {
            orderTextInputFields.map((inputField) => (
              <InputField
                key={ `customer-order-filter-form-field-${inputField?.name}` }
                type={ inputField?.type }
                name={ inputField?.name }
                label={ inputField?.label }
                placeholder={ inputField?.placeholder }
                size={ 'sm' }
              />
            ))
          }

          {
            showCustomerFields && (
              <>
                <hr />
                <Label className='mb-3 font-weight-bold'>{ 'Customer Filter' }</Label>
                {
                  customerTextInputFields.map((inputField) => (
                    <InputField
                      key={ `customer-order-filter-form-field-${inputField?.name}` }
                      type={ inputField?.type }
                      name={ inputField?.name }
                      label={ inputField?.label }
                      placeholder={ inputField?.placeholder }
                      size={ 'sm' }
                    />
                  ))
                }
              </>
            )
          }

          <div className='d-flex position-sticky fixed-bottom bg-white py-3'>
            <LoaderButton
              color='primary'
              className='w-100'
              type='submit'
              disabled={ isSubmitting }
              isLoading={ isSubmitting }
              text='Filter'
            />
            <LoaderButton
              color='danger'
              className='w-100'
              disabled={ isSubmitting }
              isLoading={ isSubmitting }
              text='Reset'
              onClick={ onClickReset }
            />
          </div>
        </Form>
      )
    }
  </Formik>
)

CustomerOrderFilterForm.propTypes    = propTypes
CustomerOrderFilterForm.defaultProps = defaultProps

export default CustomerOrderFilterForm
